import type {
  DetailedHTMLProps,
  FC,
  PropsWithChildren,
  SelectHTMLAttributes,
} from 'react';
import { Container } from './style';

type SelectProps = DetailedHTMLProps<
  SelectHTMLAttributes<HTMLSelectElement>,
  HTMLSelectElement
>;

const Select: FC<PropsWithChildren<SelectProps>> = ({ children, ...props }) => {
  return <Container {...props}>{children}</Container>;
};

export default Select;
